(function () {
  'use strict';

  angular
    .module('veiculos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.veiculos', {
        url: '/veiculos',
        views: {
          'content@': {
            templateUrl: 'veiculos/veiculos.tpl.html',
            controller: 'VeiculosCtrl',
            controllerAs: 'veiculosCtrl'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.transferenciaDeVeiculos.menuLabel',
          tituloDescricao: '',
          role: 'VEICULO_PERMISSAO_VISUALIZAR'
        }
      });
  }
}());
